import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import intl from 'react-intl-universal';
import { fnShowNewDashboard } from 'src/helpers/commonFunctions';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '45px',
    backgroundColor: theme.palette.background.paper,
    padding: '0',
    boxShadow: '0 2px 7px 0 rgba(0,0,0,0.03)',
  },
  tabsIndicator: {
    backgroundColor: '#000',
    bottom: '-2px',
    height: '3px',
    zIndex: 2,
  },
  invisible: {
    display: 'none',
  },
  fixed: {
    overflowX: 'initial',
  },
  tabsRoot: {
    overflow: 'initial',
  },
  tabRoot: {
    textTransform: 'initial',
    fontSize: '1rem',
    //minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    fontFamily: 'EYInterstate Light',
    //marginRight: theme.spacing.unit * 4,
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#000',
      fontWeight: theme.typography.fontWeightMedium,
      fontFamily: 'EYInterstate',
    },
    '&:focus': {
      color: '#000',
    },
  },

  tabSelected: {},
  typography: {
    padding: theme.spacing(3),
  },
});

class CasesDetailsTabPres extends React.Component {
  render() {
    const {
      caseMessagesCount,
      classes,
      tab,
      isStatusFormPresent,
      isAdditionalInfoSecExist,
      onChange,
      docCount,
      contactsCount,
    } = this.props;

    return (
      <div className={classes.root}>
        <Tabs
          value={tab}
          onChange={onChange}
          classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator, fixed: classes.fixed }}
          variant="scrollable"
          scrollButtons="auto">
          <Tab classes={{ root: classes.tabRoot, selected: classes.tabSelected }} label={intl.get('cases.details.tabs.details')} />
          {isStatusFormPresent ? (
            <Tab
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
              label={intl.get('cases.details.tabs.bpfStatusInformation')}
            />
          ) : (
            <Tab
              classes={{ root: classes.invisible, selected: classes.tabSelected }}
              label={intl.get('cases.details.tabs.bpfStatusInformation')}
            />
          )}
          {!fnShowNewDashboard() && (
            <React.Fragment>
              {isAdditionalInfoSecExist ? (
                <Tab
                  classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                  label={intl.get('cases.details.tabs.additionalInformation')}
                />
              ) : (
                <Tab
                  classes={{ root: classes.invisible, selected: classes.tabSelected }}
                  label={intl.get('cases.details.tabs.additionalInformation')}
                />
              )}
              <Tab
                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                label={`${intl.get('cases.details.tabs.messages')} (${caseMessagesCount})`}
              />
              <Tab
                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                label={`${intl.get('cases.details.tabs.documents')} (${docCount})`}
              />
              <Tab
                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                label={`${intl.get('cases.details.tabs.caseContacts')} (${contactsCount})`}
              />
            </React.Fragment>
          )}
        </Tabs>
      </div>
    );
  }
}

CasesDetailsTabPres.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CasesDetailsTabPres);
